export const FileManageRoutes = [
  {
    path: '/Admin/FileManage/EvaluationFiles',
    name: '测评相关文件管理',
    component: () => import('./EvaluationFiles/index.vue'),
    meta: {
      title: '测评相关文件管理'
    }
  }
]



// WEBPACK FOOTER //
// ./src/pages/Admin/AdminHome/FileManage/routes.js